import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'durationTranslation'
})
export class DurationTranslationPipe implements PipeTransform {

  constructor(private translate: TranslateService) {
  }

  transform(value: string): string {
    switch (value) {
      case 'MINIMAL':
        return this.translate.instant('ONBOARDING.USE_CASE_LEVELS.MINIMAL');
      case 'SHORT':
        return this.translate.instant('ONBOARDING.USE_CASE_LEVELS.SHORT');
      case 'BASIC':
        return this.translate.instant('ONBOARDING.USE_CASE_LEVELS.BASIC');
      case 'MORE':
        return this.translate.instant('ONBOARDING.USE_CASE_LEVELS.MORE');
    }
    return value;
  }

}
